import request from '@/utils/request2'

// 列表(主数据列表)
export function loadWeChatGroupListDataApi(data) {
  return request({
    url: 'tms-web/weChatGroup/listByPage',
    method: 'post',
    data
  })
}

// 导出
export function exportWeChatGroupListDataApi(data) {
  return request({
    url: 'tms-web/weChatGroup/exportByPage',
    method: 'post',
    data
  })
}

// 保存
export function saveWeChatGroupApi(data) {
  return request({
    url: 'tms-web/weChatGroup/save',
    method: 'post',
    data
  })
}

// 作废
export function deleteWeChatGroupApi(data) {
  return request({
    url: 'tms-web/weChatGroup/delete',
    method: 'post',
    data
  })
}

// 查看
export function viewWeChatGroupApi(data) {
  return request({
    url: 'tms-web/weChatGroup/view',
    method: 'post',
    data
  })
}
